<template>
  <div class="section-main__warp visitor-wrap">
    <ioc-table ref="crud"
               :data="tableData"
               :option="option"
               :page="page"
               @export-change="exportDocument"
               @search-change="handleSearchChange"
               @search-reset="handleSearchReset"
               @size-change="handleSizeChange"
               @current-change="handleCurrentChange"
               @refresh-change="refreshChange"
               @selection-change="handleSelectionChange">
      <template slot="fileCode"
                slot-scope="scope">
        <img :src="imgPath(scope.row.fileCode)"
             @click="showViewer(imgPath(scope.row.fileCode), $event)"
             onerror="this.src='/images/theme/newDark/default.png'"
             style="height: 25px; width: 50px" />
      </template>
      <template slot="name"
                slot-scope="scope">
        <div v-if="scope.row.authChannel == '5'">{{ scope.row.authName }}</div>
        <div v-else>{{ scope.row.name }}</div>
      </template>
      <!-- 失效红色色 已授权高亮展示 -->
      <template slot="authStatus"
                slot-scope="scope">
        <span v-if="scope.row.authStatus === '2'"
              style="color: red; cursor: pointer;"
              @click="handleView(scope.row, scope.index)">已失效</span>
        <span v-else
              style="color: #00e8bb; cursor: pointer;"
              @click="handleView(scope.row, scope.index)">已授权</span>
      </template>
      <template slot="menu"
                slot-scope="scope">
        <el-tooltip class="item"
                    effect="dark"
                    content="详情"
                    placement="top"
                    popper-class="tooltip-draw">
          <el-button type="text"
                     icon="iconfont icon-Detail"
                     @click="handleView(scope.row, scope.index)"></el-button>
        </el-tooltip>
      </template>
      <!-- 详情页面中的原单详情 -->
      <template slot="viewFormSet"
                slot-scope="scope">
        <div class="original-btn"
             v-if="scope.row.authChannel == '2' || scope.row.authChannel == '3'">
          <el-button type="primary"
                     @click="getOriginalDetail(scope.row.authChannel)">查看原单详情</el-button>
        </div>
      </template>
      <template slot="nameView"
                slot-scope="scope">
        <div v-if="scope.row.authChannel == '5'">{{ scope.row.authName }}</div>
        <div v-else>{{ scope.row.name }}</div>
      </template>
    </ioc-table>
    <detail-dialog ref="detailDialog"></detail-dialog>
    <car-detail-dialog ref="carDetail"
                       :detailData="detailData"
                       :workFlowDetail="workFlowData"></car-detail-dialog>
    <viewer @inited="inited"
            :images="viewerPhotos"
            class="viewer"
            ref="viewer">
      <img v-for="src in viewerPhotos"
           :src="src"
           :key="src" />
    </viewer>
  </div>
</template>
<script>
import { Dic, Bus, Dates } from '$utils'
import { api } from '../api'
import utils from '@src/common/utils'
import carTableOption from '../const/carAuthorizationRecord'
import detailDialog from '../components/details-dialog'
import carDetailDialog from '../../carApprovalRecord/components/detailDialog'
export default {
  components: { detailDialog, carDetailDialog },
  filters: {
    sexFilter (val, SENU) {
      return Dic.findByValue('SENU018', val)
    },
    colorFilter (val) {
      return Dic.findByValue('SENU039', val)
    },
    vehicleTypeFilter (val) {
      return Dic.findByValue('SENU038', val)
    },
    formartterTime (time) {
      return time ? Dates.dayjs(Number(time)).format('YYYY-MM-DD HH:mm:ss') : ''
    },
    flowTypeFilter (val) {
      return Dic.findByValue('SENU080002', val)
    },
    flowStatusFilter (val) {
      return Dic.findByValue('SENU080003', val)
    },
  },
  data () {
    return {
      viewerInstance: null,
      viewerPhotos: [],
      tableData: [],
      option: carTableOption(),
      page: {
        pageNum: 1,
        total: 0,
        pageSize: utils.Cache.get('CURRENT_PAGESIZE') || 10,
      },
      searchParams: {
        status: '',
        name: '',
        plateCode: '',
        pageNum: 1,
        pageSize: utils.Cache.get('CURRENT_PAGESIZE') || 10,
      },
      currentCode: '',
      detailData: {},
      workFlowData: [],
    }
  },
  mounted () {
    this.getList()
  },
  created () { },
  methods: {
    imgPath (item) {
      return item ? Bus.imgPath(item) : ''
    },
    inited (viewer) {
      this.viewerInstance = viewer
    },
    showViewer (src, e) {
      this.viewerPhotos = [
        e.target.src.indexOf('default/default.png') == -1
          ? e.target.src + '&sourceFileFlag=1'
          : e.target.src,
      ]
      this.viewerInstance.show()
    },
    statusFormatter (data) {
      switch (data.status * 1) {
        // 1:待接待人审批,2:接待人审批通过,待部门负责人审批3:部门负责人审批通过,待区域负责人审批4:区域负责人同意5:拒绝'
        case 1:
          return '待审批'
        case 2:
          return '已通过'
        case 3:
          return '已拒绝'
        default:
          return data.status
      }
    },
    isFactoryFormatter (data) {
      switch (data * 1) {
        //
        case 0:
          return '厂内'
        case 1:
          return '厂外'
        default:
          return data
      }
    },
    //导出
    exportDocument () {
      const params = {
        status: this.searchParams.status ? this.searchParams.status : '', // 4 同意 5 拒绝
        name: this.searchParams.name ? this.searchParams.name : '',
        beginTime:
          this.searchParams.createTime && this.searchParams.createTime.length
            ? Dates.format(this.searchParams.createTime[0])
            : '', //'开始时间',
        endTime:
          this.searchParams.createTime && this.searchParams.createTime.length
            ? Dates.format(this.searchParams.createTime[1])
            : '', //结束时间',
        plateCode: this.searchParams.plateCode
          ? this.searchParams.plateCode
          : '',
      }
      // 兼容IE
      this.option.exportDisabled = true
      this.$fetchDownLoad(api.exportVisitorApplyRecordList, params, {
        responseType: 'arraybuffer',
      }).then((response) => {
        const content = response.data
        const blob = new Blob([content], { type: 'application/zip' })
        const fileName =
          '访客预约记录信息' +
          Dates.format(Date.now(), 'yyyyMMddHHmmssms') +
          '.zip'
        if ('download' in document.createElement('a')) {
          // 非IE下载
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
        this.option.exportDisabled = false
      })
    },
    // 重置列表
    handleSearchReset () {
      this.searchParams = {}
      this.getList()
    },
    // 获取预约记录
    getList () {
      const params = {
        // status: this.searchParams.status ? this.searchParams.status : "", // 4 同意 5 拒绝
        // beginTime: this.searchParams.createTime && this.searchParams.createTime.length
        //   ? Dates.format(this.searchParams.createTime[0])
        //   : '', //'开始时间',
        // endTime: this.searchParams.createTime && this.searchParams.createTime.length
        //   ? Dates.format(this.searchParams.createTime[1])
        //   : '', //结束时间',
        authChannel: this.searchParams.authChannel,
        name: this.searchParams.name ? this.searchParams.name : '',
        plateCode: this.searchParams.plateCode
          ? this.searchParams.plateCode
          : '',
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
      }
      const loading = this.$loading({
        lock: true,
        text: '请求中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.$fetch(api.getRecordList, params).then((response) => {
        setTimeout(() => {
          loading.close()
        }, 500);

        if (!response.success) {
          this.$message({
            message: response.msgContent,
            type: 'error',
            duration: 2000,
          })
          return
        }
        this.tableData = response.returnObj
          ? Object.freeze([...response.returnObj.list])
          : []
        this.page.total = response.returnObj ? response.returnObj.total : 0
        this.$refs.crud.selectClear()
      })
    },
    refreshChange (page) {
      this.getList(page)
    },
    handleCurrentChange (val) {
      this.page.pageNum = val
      this.refreshChange(this.page)
    },
    handleSizeChange (val) {
      this.page.pageNum = 1
      this.page.pageSize = val
      this.refreshChange(this.page)
    },
    handleSearchChange (param) {
      this.searchParams = Object.assign({}, param)
      this.getList()
    },
    handleSelectionChange (items) {
      this.checkedAccounts = items.map((item) => {
        return item.workGroupCode
      })
    },
    handleView (row, index) {
      if (row.authChannel == '2' || row.authChannel == '3') {
        this.currentCode = row.refCode
      }
      this.$refs.crud.rowView(row, index)
    },
    getOriginalDetail (data) {
      // 2：访客预约，3：车辆申请
      if (data == '2') {
        this.$refs.detailDialog.open(this.currentCode)
      } else if (data == '3') {
        let params = {
          appointmentCode: this.currentCode,
        }
        this.$fetch(api.car.getDetails, params).then((response) => {
          if (!response.success) {
            this.$message.error(response.msgContent)
            return
          }
          this.detailData = response.returnObj
        })
        this.$fetch(api.car.getWorkFlow, params).then((response) => {
          if (!response.success) {
            this.$message.error(response.msgContent)
            return
          }
          this.workFlowData = response.returnObj
        })
        this.$nextTick(() => {
          this.$refs.carDetail.open()
        })
      }
    },
  },
}
</script>
<style lang="scss">
@import "../style/visitorRecord.scss";
</style>
